import React, { useState, useEffect } from 'react';
import { connect } from '../../redux/store';
import { Router } from '@reach/router';
import { PageTitle } from '../shared/PageTitle';
import { ErrorMessage } from '@kineticdata/bundle-common';

import { AgreementTeams } from './AgreementTeams';
import { AgreementTeam } from './AgreementTeam';

export const ApprovalManagement = connect(state => ({
  hasApprovalManagementAccess: state.settingsApp.hasApprovalManagementAccess,
  profile: state.app.profile,
}))(({ hasApprovalManagementAccess }) => {
  const [pageSize, setPageSize] = useState(25);
  const [index, setIndex] = useState(0);
  useEffect(
    () => {
      setIndex(0);
    },
    [pageSize],
  );

  return hasApprovalManagementAccess ? (
    <Router>
      <AgreementTeam path=":agreement" />
      <AgreementTeams
        pageSize={pageSize}
        setPageSize={setPageSize}
        index={index}
        setIndex={setIndex}
        default
      />
    </Router>
  ) : (
    <div className="page-container">
      <div className="page-panel">
        <PageTitle
          parts={['Approval Management']}
          breadcrumbs={[]}
          title="Approval Management"
        />
        <ErrorMessage
          title="Unauthorized"
          message="You do not have permission to access approval management."
        />
      </div>
    </div>
  );
});
